// extracted by mini-css-extract-plugin
module.exports = {"boxIcon":"RVX93ka3zfA_IHsrffac2"};